import QuizRepositoryI from '../repository/QuizRepositoryI';
import QuizServiceI from './QuizServiceI';
import { QuizCreatedI, QuizGetI, UpdateQuizResponseI } from '../domain';

export default class QuizServiceImpl implements QuizServiceI {
  constructor(private quizRepository: QuizRepositoryI) {}

  public async create(customerId: string): Promise<QuizCreatedI> {
    return this.quizRepository.create(customerId) as Promise<QuizCreatedI>;
  }

  public async update({
    idQuiz,
    customerId,
    questions,
  }: {
    idQuiz: string;
    customerId: string;
    questions: {
      id: string;
      responses: {
        id: string;
      }[];
    }[];
  }): Promise<UpdateQuizResponseI> {
    return this.quizRepository.update(customerId, idQuiz, questions);
  }

  public async getQuiz(customerId: string): Promise<QuizGetI[]> {
    const quizzes = await this.quizRepository.getQuiz(customerId);
    return quizzes;
  }
}
